let sidebar = $('#sidebar');

if(sidebar.length) {
    sidebar.find('.btn-collapse').click(function () {

        if (sidebar.hasClass('active-load')) {
            if ($(window).width() >= 992) {
                sidebar.removeClass('active');
            }
            sidebar.removeClass('active-load');
        } else {
            sidebar.toggleClass('active');
        }

        if (sidebar.hasClass('active')) {
            document.cookie = 'sidebar-toggle=1;SameSite=lax; path=/';
            return;
        }
        document.cookie = 'sidebar-toggle=0;SameSite=lax; path=/';
    });

    /* Check control key press. */
    var ctrlPressed = false;
    $(document).keydown(function (e) {
        if (e.ctrlKey) {
            ctrlPressed = true;
        }
    }).keyup(function (e) {
        if (e.ctrlKey) {
            ctrlPressed = false;
        }
    });

    /* Open/close filters on Ctrl-f key press. */
    $(document).keydown(function (e) {
        if (ctrlPressed && e.which === 70) {
            e.preventDefault();
            sidebar.toggleClass('active');

            if (sidebar.hasClass('active')) {
                let input = $('#sidebar').find('input[type!="hidden"], select, textarea').first().focus();
                input[0].setSelectionRange(0, input.val().length ?? 0);
                document.cookie = 'sidebar-toggle=1;SameSite=lax; path=/';
                return;
            }
            document.cookie = 'sidebar-toggle=0;SameSite=lax; path=/';
            ctrlPressed = false;
        }
    });
}
